import { api } from './api';

/**
 * Save an edit from the vendor screen. The server carries it on to the
 * vendor's Kore lead, and refuses the save when Kore does not accept it.
 *
 * @param {string|number} id ARCIMEDES_ROW_ID
 * @param {Object} vendor the row as the screen holds it
 * @returns {Promise<Object>} the saved vendor row
 */
export function updateVendor(id, vendor) {
    return api.patch(`/vendors/${id}`, vendor).then((res) => res.data);
}
